import { darkBlue, darkRedPrimary } from 'src/styles/colors';
import styled from 'styled-components';
import Button from '../Button';

export const CloseBtn = styled(Button)`
  color: ${({ color }) => (color === 'darkBlue' ? darkBlue : darkRedPrimary)};

  &:hover {
    color: ${({ color }) => (color === 'darkBlue' ? darkBlue : darkRedPrimary)};
    cursor: pointer;
  }
`;
